module.exports = __webpack_public_path__ + "img/connects.bd0ed34b.jpg";